import { Alert, Box, Collapse } from "@mui/material";

const returnReasonSeverityByStatusDataKey = {
  approved: "success",
  cancelled: "error",
  "for-resubmit": "warning",
  partially_approved: "warning",
  pending_review: "warning",
  rejected: "error",
  resubmitted: "warning",
  saved: "info",
  submitted: "warning",
};

const returnReasonTitleByStatusDataKey = {
  approved: "Σχόλια Έγκρισης",
  cancelled: "Λόγοι Ακύρωσης",
  "for-resubmit": "Λόγοι Επιστροφής στον Φορέα",
  partially_approved: "Σχόλια Μερικής Έγκρισης",
  pending_review: "Σχόλια Ελέγχου",
  rejected: "Λόγοι Απόρριψης",
  resubmitted: "Σχόλια Επανυποβολής",
  saved: "Σχόλια Κατάστασης",
  submitted: "Σχόλια Υποβολής",
};

const getStatusCommentsText = (statusComments) =>
  statusComments?.toString?.().trim?.() ?? "";

const normalizeStatusDataKey = (statusDataKey) =>
  statusDataKey?.toString?.().trim?.().toLowerCase?.() ?? "";

const getReturnReasonSeverity = (statusDataKey) => {
  const normalizedStatusDataKey = normalizeStatusDataKey(statusDataKey);
  return returnReasonSeverityByStatusDataKey[normalizedStatusDataKey] ?? "info";
};

const getReturnReasonTitle = (statusDataKey) => {
  const normalizedStatusDataKey = normalizeStatusDataKey(statusDataKey);
  return (
    returnReasonTitleByStatusDataKey[normalizedStatusDataKey] ??
    "Σχόλια Κατάστασης"
  );
};

const ReturnReasonsAccordion = ({
  enabled = false,
  statusComments,
  statusDataKey,
}) => {
  const commentsText = getStatusCommentsText(statusComments);

  if (!enabled || !commentsText) return null;

  return (
    <Collapse in>
      <Alert
        variant="filled"
        severity={getReturnReasonSeverity(statusDataKey)}
        sx={{
          alignItems: "flex-start",
          "& .MuiAlert-message": {
            width: "100%",
          },
        }}
      >
        <Box sx={{ fontWeight: 900, mb: 0.5 }}>
          {getReturnReasonTitle(statusDataKey)}
        </Box>
        <Box
          sx={{
            fontWeight: 600,
            lineHeight: 1.45,
            overflowWrap: "anywhere",
            whiteSpace: "pre-wrap",
          }}
        >
          {commentsText}
        </Box>
      </Alert>
    </Collapse>
  );
};

export default ReturnReasonsAccordion;
